/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Status, ajax } from '../../twd'

export default () => {

    const [status, setStatus] = React.useState(Status.LOADING)
    const [recentSearches, setRecentSearches] = React.useState([])
    const lastAbort = React.useRef()

    React.useEffect(() => {

        var dismounted = false

        ;(async () => {
        if (status!==Status.LOADING) return

        try {
            if (lastAbort.current) {
                lastAbort.current()
            }

            let {data, abort} = ajax({
                url: '/esb/generic/masterConfig',
                params: ['portfolio_recent_searches']
            })
            lastAbort.current = abort

            let rs = ((await data).portfolio_recent_searches || [])
                .map(a => {
                    a.searchParams = (a.queryText || {}).metadata || a.queryText || {}
                    return a
                })
                .filter(a => {
                    return a.searchParams.searchType === 'offers'
                })
                .slice(0, 5)

            if (dismounted) return

            setRecentSearches(rs)

            setStatus(Status.LOADED)
        } catch(e) {
            if (dismounted) return
            setStatus(Status.FAILED_TO_LOAD)
        }
        })()

        return () => {
            dismounted = true

            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
        }

    } , [])


    return { status, recentSearches }

}